export default __webpack_public_path__ + "static/worksurface-1831ba905d554a813834aad7e1c9f821.png";